/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { PropsWithChildren } from "react";
import { Else, If, Then } from "react-if";
import { Link } from "react-router-dom";
import { Text } from "@nordcloud/gnui";
import { isNotNil } from "~/tools";

type Props = PropsWithChildren<{
  linkTo?: string;
  region: string;
  showAccount: boolean;
}>;

export function AccountRegionCell({
  linkTo,
  region,
  children,
  showAccount,
}: Props) {
  return (
    <>
      <If condition={showAccount}>
        <Then>
          <div style={{ wordBreak: "break-all" }}>
            <If condition={isNotNil(linkTo)}>
              <Then>
                <Link to={linkTo ?? ""}>{children}</Link>
              </Then>
              <Else>{children}</Else>
            </If>
          </div>
        </Then>
      </If>
      <Text tag="div" size={showAccount ? "sm" : undefined}>
        {region}
      </Text>
    </>
  );
}
